<div class="pill">
  <ng-content></ng-content>
</div>
<div *ngIf="messageMetadata" [class.show]="isMetadataPresented" class="metadata">
  {{ messageMetadata }}
</div>
